import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=6e6a9b48&scoped=true"
import script from "./Modify.vue?vue&type=script&lang=js"
export * from "./Modify.vue?vue&type=script&lang=js"
import style0 from "./Modify.vue?vue&type=style&index=0&id=6e6a9b48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6a9b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6a9b48')) {
      api.createRecord('6e6a9b48', component.options)
    } else {
      api.reload('6e6a9b48', component.options)
    }
    module.hot.accept("./Modify.vue?vue&type=template&id=6e6a9b48&scoped=true", function () {
      api.rerender('6e6a9b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/standardphone/Modify.vue"
export default component.exports